import { ALL_SPREAD_DEFINITIONS } from './derived/all-spreads.js';
import { LILITH_FOCUS_MODES } from './focus-modes/lilith-focus.js';
import { RELATIONSHIP_FOCUS_MODES } from './focus-modes/relationship-focus.js';
import { SHADOW_FOCUS_MODES } from './focus-modes/shadow-focus.js';
import { YEARLY_FOCUS_MODES } from './focus-modes/yearly-focus.js';
import { SPREAD_REGISTRY_GENERATED_AT, SPREAD_REGISTRY_VERSION } from './meta/registry-version.js';
export const SPREAD_REGISTRY_MANIFEST = {
    id: 'lilith-arcana-spreads',
    version: SPREAD_REGISTRY_VERSION,
    total_spreads: ALL_SPREAD_DEFINITIONS.length,
    total_focus_modes: LILITH_FOCUS_MODES.length +
        RELATIONSHIP_FOCUS_MODES.length +
        YEARLY_FOCUS_MODES.length +
        SHADOW_FOCUS_MODES.length,
    supports_custom_templates: true,
    supports_mobile_variants: true,
    generated_at: SPREAD_REGISTRY_GENERATED_AT,
};
//# sourceMappingURL=manifest.js.map